<!-- vertical 竖 -->
<template>
  <div class="columns is-variable is-6-desktop is-multiline">
    <div class="column is-one-third" v-for="(item, index) in items" :key="index" @click="item.path ? goNext(item):''">
      <div class="card is-clickable" tabindex="0"
        :style="{ background: item.bg_color ? item.bg_color : '', cursor: item.path ? 'pointer' : '' }">
        <div class="card-image">
          <figure class="image is-3by2">
            <!-- <img v-if="item.image" :src="item.image" /> -->
            <!-- <img v-if="item.image" :src="item.image" /> -->
            <!-- image -->
            <template v-if="item.banner_type == 1">
              <img v-if="item.image" :src="item.image" class="banner_img card_img" />
            </template>
            <!-- mp4 -->
            <template v-else-if="item.banner_type == 2">
              <video v-if="item.mp4_url" id="home_video" controls loop muted>
                <source :src="item.mp4_url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </template>
            <!-- Yutube -->
            <template v-else-if="item.banner_type == 3">
              <div class="iframe-wrap" v-html="item.video_url"></div>
            </template>
          </figure>
        </div>
        <div class="card-content">
          <h4 class="title is-4">{{ item.title }}</h4>
          <div class="subtitle subtitle_page_html is-6 has-text-weight-medium" v-html="item.desc">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {};
  },
  async created() {},
  methods: {
    goNext(item) {
      // this.$router.push({
      //   path: item.path,
      // });
      window.location.href = item.path;
    },
  },
};
</script>

<style scoped>
.card {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 8px 16px -4px #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  color: #757763;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.card:hover {
  top: -4px;
  left: -1px;
  box-shadow: 0 0 29px #b9b9b9, 0 0 29px #fff;
  transition: all 0.5s ease-in-out;
}
.card-image {
  display: flex;
  position: relative;
}
.card-image img {
  max-width: 100%;
}
.title.is-4 {
  font-size: 1.5rem;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.125;
}

.subtitle {
  color: #757763;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 600 !important;
  margin-top: 4px;
}
.column {
  padding: 24px;
  box-sizing: border-box;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns.is-multiline {
  flex-wrap: wrap;
}
.columns.is-variable {
  --columnGap: 0.75rem;
  margin-left: calc(-1 * var(--columnGap));
  margin-right: calc(-1 * var(--columnGap));
}
.columns.is-variable > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.card-content {
  background-color: transparent;
  padding: 24px;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 20px;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}

.mt-4 {
  margin-top: 16px !important;
}
.tag {
  font-weight: 800;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 12px;
  height: 32px;
  justify-content: center;
  line-height: 1.5;
  padding-left: 12px;
  padding-right: 12px;
  white-space: nowrap;
}
.lead {
  text-align: center;
}
.mr-4 {
  margin-right: 16px !important;
}
.tag:not(body).is-rounded {
  border-radius: 290486px;
}
.tag:not(body).is-medium {
  font-size: 1rem;
}
.tag:not(body).is-danger {
  background-color: #de4c50;
  color: #fff;
}

.tag {
  font-weight: 800;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.tag:not(body).is-info {
  background-color: #276cda;
  color: #fff;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.is-clickable {
  pointer-events: all !important;
}
.card-image:first-child img {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.mr-0 {
  margin-right: 0 !important;
}
.image {
  display: block;
  position: relative;
  width: 100%;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
  max-height: 293px;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 33.3333%;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 33.3333%;
  }
}
@media screen and (min-width: 1024px) {
  .columns.is-variable.is-6-desktop {
    --columnGap: 1.5rem;
  }
}
@media screen and (min-width: 1408px) {
}
.image {
  display: block;
  position: relative;
}
#home_video {
  max-width: 100%;
  height: 250px;
}
.card_img {
  height: 250px;
}
.iframe-wrap {
  height: 250px;
}
</style>
<style>
.subtitle_page_html p {
  word-break: break-word !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Card/PageCard.vue